import React, { useState, useEffect } from 'react';
import TinyEditor from '@sg/components/TinyEditor';

interface InputTextComponentProps {
    value: any;
    record: any;
    editData?: any[];
    stableUpdater?: (value: any) => void;
    fieldKey: string;
}

const InputTextComponent: React.FC<InputTextComponentProps> = ({
    value,
    record,
    editData,
    stableUpdater,
    fieldKey
}) => {
    // 优先从 editData 中获取值
    const getCurrentValue = () => {
        if (editData && record?.id) {
            const editRecord = editData.find((item: any) => item.id === record.id);
            if (editRecord && editRecord[fieldKey] !== undefined) {
                return editRecord[fieldKey];
            }
        }
        return value || '';
    };

    const [inputValue, setInputValue] = useState(getCurrentValue());

    // Sync with editData changes (for auto-save restore) and record.id changes
    useEffect(() => {
        const currentValue = getCurrentValue();
        setInputValue(currentValue);
    }, [record?.id, editData]);

    const handleChange = (newValue: any) => {
        setInputValue(newValue);
        // 使用 stableUpdater 更新数据
        if (stableUpdater) {
            stableUpdater(newValue);
        }
    };

    return (
        <TinyEditor
            value={inputValue}
            getEditorContent={handleChange}
        />
    );
};

export default InputTextComponent;
